const AvatarsColors = [
  '#5F2A6A',
  '#583d72',
  '#9f5f80',
  '#ffba93',
  '#ff8e71',
  '#e7d9ea',
  '#11698e',
  '#19456b',
  '#16c79a',
  '#433d3c',
  '#944e6c',
  '#e9c496',
  '#83a95c',
  '#cd5d7d',
  'f6ecf0',
  '#a7c5eb',
  '#949cdf',
  '#ffd66b',
  '#ff9d72',
];

export default AvatarsColors;
